class VariantSelects extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const isProductCard = this.hasAttribute('data-product-card');

    this.addEventListener('change', (event) => {
      const target = this.getInputForEventTarget(event.target);

      // Check if this change event is from a 'popout-select' dropdown that should trigger variant change
      this.triggerPopoutVariantChange(target);

      const changedPosition = parseInt(target.closest('[data-option-position]')?.dataset.optionPosition);
      const optionsLength = this.querySelectorAll('[data-option-position]').length;
      // const selectedOptionValues = isNaN(changedPosition)
      //   ? this.selectedOptionValues
      //   : this.selectedOptionValuesUpTo(changedPosition);

      const selectedOptionValues = changedPosition === 1 && optionsLength > 1 ? this.selectedOptionValuesUpTo() : this.selectedOptionValues;

      publish(theme.PUB_SUB_EVENTS.optionValueSelectionChange, {
        data: {
          event,
          target,
          selectedOptionValues,
        },
      });
    });

    if (isProductCard) {
      this.addEventListener('click', (event) => {
        const label = event.target.tagName === 'LABEL' ? event.target : event.target.closest('label');
        if (!label || !label.closest('fieldset')) return;

        const input = document.getElementById(label.getAttribute('for'));
        if (!input || input.type !== 'radio' || !input.dataset.optionValueId || input.checked) return;

        const selectedOptionValues = this.selectedOptionValues;
        const index = Array.from(this.querySelectorAll('fieldset input:checked')).findIndex((radio) => radio.name === input.name);
        if (index !== -1) selectedOptionValues[index] = input.dataset.optionValueId;

        const selectionJSON = JSON.stringify(selectedOptionValues);
        if (VariantSelects.lastSelection === selectionJSON) return;
        VariantSelects.lastSelection = selectionJSON;

        publish(theme.PUB_SUB_EVENTS.optionValueSelectionChange, {
          data: {event, target: input, selectedOptionValues},
        });
      });
    }
  }

  getInputForEventTarget(target) {
    return target.tagName === 'SELECT' ? target.selectedOptions[0] : target;
  }

  get selectedOptionValues() {
    const selectedNativeDropdowns = Array.from(this.querySelectorAll('select option[selected]'));
    const selectedRadios = Array.from(this.querySelectorAll('fieldset input:checked'));
    const selectedPopouts = Array.from(this.querySelectorAll('[data-popout-input]'));

    return [...selectedNativeDropdowns, ...selectedRadios, ...selectedPopouts].map(({dataset}) => dataset.optionValueId).filter((id) => Boolean(id));
  }

  selectedOptionValuesUpTo() {
    return Array.from(this.querySelectorAll('[data-option-position]'))
      .map((container) => {
        const pos = parseInt(container.dataset.optionPosition);
        const selectedInput =
          container.querySelector('select option[selected]') ||
          container.querySelector('fieldset input:checked') ||
          container.querySelector('[data-popout-input]');

        const firstInput =
          container.querySelector('select option') ||
          container.querySelector('fieldset input') ||
          container.querySelector('[data-popout-input]');

        const input = pos === 2 ? firstInput : selectedInput;

        return input?.dataset?.optionValueId;
      })
      .filter(Boolean);
  }

  /**
   * Trigger variant change from a popout-select dropdown
   * @param {HTMLElement} target - The target element that triggered the change event
   */
  triggerPopoutVariantChange(target) {
    // check if the target is the correct input
    if (!target || !target.hasAttribute('data-popout-input')) return;

    // check if the popout-select has the correct attribute
    const popoutSelect = target.closest('popout-select');
    if (!popoutSelect || !popoutSelect.hasAttribute('data-variant-change')) return;

    // get the variant ID from the target
    const variantId = target.getAttribute('data-variant-id');
    if (!variantId) return;

    // get the target form and the variant ID input
    const targetForm = this.closest('form');
    const variantIdInput = targetForm?.querySelector('[name="id"]');
    if (!targetForm || !variantIdInput) return;

    // set the variant ID value and trigger the variant change
    variantIdInput.value = variantId;
    variantIdInput.dispatchEvent(new Event('change', {bubbles: true}));
  }
}

customElements.define('variant-selects', VariantSelects);
